import type { ZiItem } from "./zi_defs";

export const names: { [key: string]: any } = {
  "Ambitious Arrangement": {
    sku: "Z2421",
    listed: false,
  },
  "Confident Conviction": {
    sku: "Z2424",
    listed: false,
  },
  "Indulgent Ideal": {
    sku: "Z2425",
    listed: false,
  },
  "Intentional Impression": {
    sku: "Z2423",
    listed: false,
  },
  "Sentimental Value": {
    sku: "Z2422",
    listed: false,
  },
  Assertive: {
    sku: "Z2416",
    text: `Timeless white rhinestones and jet black gems burst into abstract frames, sliding along a twisted silver chain below a series of solitaires.`,
  },
  Brazen: {
    sku: "Z2426",
    text: `Turquoise stones spin into circular frames, leading down the neckline to an exaggerated squash blossom pendant at the center.`,
  },
  Compelling: {
    sku: "Z2418",
    text: `Rows of tiny, white, emerald-cut gems alternate with marquise-cut gems, blooming into rustic floral frames against a backdrop of brass. `,
  },
  Determined: {
    sku: "Z2411",
    text: `Exaggerated chain links interlock along the neckline, displaying a series of rhinestone-encrusted spades and chiseled hematite gems.`,
  },
  Devoted: {
    sku: "Z2420",
    text: `An enchanting collection of heart-shaped charms decorates a thick silver chain, revealing a sentimental showcase of texture and detail, grounded by natural turquoise.`,
  },
  Elated: {
    sku: "Z2417",
    text: `Colorful round and oval gems are bordered in elegant gold frames, wrapping along the neckline in kaleidoscopic layers.`,
  },
  Endearing: {
    sku: "Z2419",
    text: `A dazzling array of peach, white, and iridescent gems adorn an intricate backdrop of shiny copper fittings, swirling into a glowing statement piece.`,
  },
  Extravagant: {
    sku: "Z2412",
    text: `Dainty, twisted chains and strands of sparkling rhinestones drape below a choker of glittery white gems, creating deceptively effortless layers of glitz.`,
  },
  Nostalgic: {
    sku: "Z2414",
    text: `Classic white pearls and sparkling spheres drape down the chest next to twisted silver chains, colliding with a velvet ribbon woven through oversized chain links in a textured display of modern refinement.`,
  },
  Relentless: {
    sku: "Z2415",
    text: `Strands of sleek, gold, snake chain drape down the neckline into an irresistible medley of metallic sheen.`,
  },
  Sincere: {
    sku: "Z2413",
    text: `Oversized white gems serve as hypnotic centerpieces for a series of abstract floral frames, radiating with vintage refinement and endless sparkle.`,
  },
  Aleshia: {
    sku: "Z2410",
    text: `Ribbons of rhinestones, classic white pearls, and radiant gems form a collection of vintage-inspired clusters, delivering regal refinement and captivating sparkle.

Named after the 2024 Seize the Spotlight winner, Aleshia H.`,
    signature: true,
  },
  Crystal: {
    sku: "Z2401",
    text: `Gold rings encrusted with rhinestones, sparkle in between dramatic, asscher-cut gems, creating a stunning display of hypnotic shimmer.

Named after the 2024 Seize the Spotlight winner, Crystal A.`,
    signature: true,
  },
  Gesphania: {
    sku: "Z2403",
    text: `Dazzling white teardrops and sparkling, curled flourishes link into an elegant collar, leading the eye to an abstract floral centerpiece.

Named after the 2024 Seize the Spotlight winner, Gesphania H.`,
    signature: true,
  },
  Janet: {
    sku: "Z2405",
    text: `Pairs of glittery hoops break up a captivating cascade of gunmetal chains intermixed with strands of sparkling white rhinestones.

Named after the 2024 Seize the Spotlight winner, Janet S.`,
    signature: true,
  },
  Jennifer: {
    sku: "Z2406",
    text: `A curtain of silver and gunmetal chains drapes below a collar of staggered white gems, demanding a double take as the sassy fringe sways defiantly.

Named after the 2024 Seize the Spotlight winner, Jennifer E.`,
    signature: true,
  },
  Kelly: {
    sku: "Z2404",
    text: `Shimmery silver discs layer into a bold collar, creating an empowering statement piece that ripples with high-sheen texture.

Named after the 2024 Seize the Spotlight winner, Kelly L.`,
    signature: true,
  },
  Leslie: {
    sku: "Z2402",
    text: `Emerald-cut gems fall in line with precision, emitting blinding radiance at every turn as they wrap along the neckline.

Named after the 2024 Seize the Spotlight winner, Leslie M.`,
    signature: true,
  },
  McKayla: {
    sku: "Z2407",
    text: `Enchanting butterfly charms and blooming floral accents dance along the neckline in whimsical bliss, as rhinestones add a dusting of sparkle throughout the effervescent display.

Named after the 2024 Seize the Spotlight winner, McKayla M.`,
    signature: true,
  },
  Melvin: {
    sku: "Z2408",
    text: `Sleek gold curb chains are emboldened by sections of silver links dusted in glitz, creating a mixed metal masterpiece that emanates attitude.

Named after the 2024 Seize the Spotlight winner, Melvin B.`,
    signature: true,
  },
};

export async function get2024Data(): Promise<ZiItem[]> {
  const loaded: { source: any; type: string; name: string }[] = [];

  const images: any = {
    videoThumb: import.meta.glob(
      "@/assets/img/zi/Zi Thumbnail Graphics/*.jpg",
      {
        query: "preset=thumbnail",
      },
    ),
    video: import.meta.glob("@/assets/img/zi/Zi Collection Reels 2024/*.mp4"),
    item: import.meta.glob("@/assets/img/zi/Learn More Page/*/*.jpg", {
      query: "preset=thumbnail",
    }),
    model: import.meta.glob("@/assets/img/zi/Pop Ups/*/*.jpg", {
      query: "preset=thumbnail",
    }),
    sig: import.meta.glob(
      [
        "@/assets/img/zi/Product Page Signatures/Signatures_*.png",
        "!@/assets/img/zi/Product Page Signatures/Signatures_Black*.png",
      ],
      {
        query: "preset=thumbnail",
      },
    ),
    sigDark: import.meta.glob(
      "@/assets/img/zi/Product Page Signatures/Signatures_Black_*.png",
      {
        query: "preset=thumbnail",
      },
    ),
  };

  const promises = [];
  for (const group in images) {
    for (const imp in images[group]) {
      let name = imp.split(/\//g).at(-1) || "unknown";
      if (/_/.test(name)) {
        name = name.split(/_/).at(-1) || "unknown";
      }
      name = name.replace(/^The/g, "").trim();
      name = name.split(/\./g).at(0) || "unknown";

      const promise = images[group][imp]();
      promises.push(promise);
      promise.then((result: any) => {
        let source = result.default;
        if (group !== "video") {
          source = source[0];
        }
        loaded.push({
          source,
          type: group,
          name,
        });
      });
    }
  }
  await Promise.all(promises);

  return Object.keys(names).map((name) => {
    const images = loaded.filter((i) => i.name === name);
    const retval = {
      season: "2024",
      name: name.toLowerCase(),
      listed: true,
      label: name,
      signature: false,
      ...names[name],
    };
    for (const image of images) {
      retval[image.type] = image.source;
    }
    return retval;
  });
}
